import { useSuspenseQuery } from '@tanstack/react-query'
import AppDataRepository from '~repositories/impl/app-data-repository'
import { APP_QUERY_KEYS } from './query-keys'

const useMyProfile = () => {
  return useSuspenseQuery({
    queryKey: APP_QUERY_KEYS.myProfile,
    queryFn: () => AppDataRepository.getMyProfile(),
    staleTime: 1000 * 60 * 30,
    gcTime: 1000 * 60 * 60,
    retry: 2,
    refetchOnWindowFocus: true,
  })
}

export default useMyProfile
